import React from 'react'
import { useRouter } from 'next/router'

// components
import ImageWithFoster from 'components/ImageWithFoster'

// styles
import styles from './index.module.scss'

const CreatorMerchCard = props => {
  const { data, onClick } = props
  const router = useRouter()

  const handleCardClick = () => {
    if (onClick) {
      onClick(data)
    } else if (data.id) {
      router.push(`/merch/${data.id}`)
    }
  }

  return (
    <div className={styles.container} onClick={handleCardClick}>
      <div className={styles.imageArea}>
        <ImageWithFoster src={data.image} className="max-w-full max-h-full object-contain" />
      </div>
      <div className="absolute bottom-4 left-4 right-4 h-[110px] bg-white p-[15px]">
        <div className={styles.productName}>{data.name}</div>
        <div className={styles.productPrice}>From&nbsp;{data.price}</div>
        <div className="flex gap-[8px] mt-[5px]">
          {data.colors.map((color, index) => (
            <div key={index} className={styles.productColor} style={{ backgroundColor: color }} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default CreatorMerchCard
